import { on } from '@ngrx/store';
import { Delta } from 'quill';

import { JobToolActions } from 'src/app/job/job-tool.actions';
import { LoadingState } from 'src/app/utilities/state.util';

import { NewOpportunityAddInventoryActions } from './new-opportunity-add-inventory.actions';
import { NewOpportunityAddInventoryState, newOpportunityAddInventoryInitialState } from './new-opportunity-add-inventory.state';

export const newOpportunityAddInventoryReducers = [
    on(
        NewOpportunityAddInventoryActions.addInventoryContentsChanged,
        (state: NewOpportunityAddInventoryState, { inventoryText }): NewOpportunityAddInventoryState => ({
            ...state,
            inventoryText,
        }),
    ),
    on(
        NewOpportunityAddInventoryActions.buildUpdateInventoryVariablesSuccess,
        (state: NewOpportunityAddInventoryState): NewOpportunityAddInventoryState => ({
            ...state,
            callState: LoadingState.MUTATING,
        }),
    ),
    on(
        NewOpportunityAddInventoryActions.updateInventorySuccess,
        (state: NewOpportunityAddInventoryState): NewOpportunityAddInventoryState => ({
            ...state,
            callState: LoadingState.MUTATED,
        }),
    ),
    on(
        NewOpportunityAddInventoryActions.updateInventoryError,
        (state: NewOpportunityAddInventoryState, { error }): NewOpportunityAddInventoryState => ({
            ...state,
            callState: { error },
        }),
    ),
    on(
        JobToolActions.jobLoaded,
        (_state: NewOpportunityAddInventoryState, { job }): NewOpportunityAddInventoryState => {

            const comments = job?.comments?.comments ?? [];

            const lastInventoryComment = [...comments]
                .reverse()
                .find((c) => c.thread?.mode === 'Update Inventory');


            if (!lastInventoryComment) {
              return {
                ...newOpportunityAddInventoryInitialState,
              };
            }

            return {
                ...newOpportunityAddInventoryInitialState,
                inventoryText: JSON.parse(lastInventoryComment.contents) as Delta,
            };
        },
    ),
];
